<template>
    <div>
        <section class="Profile">
            <profile-picture @change="fetchData"/>
            <div class="Profile__content">
                <h2 class="Profile__name">{{ profile.name }}</h2>
                <div class="Profile__description">
                    <p v-if="profile.description">{{ profile.description }}</p>
                    <p v-else>Ajoutez ici une courte description de vous dans &laquo; Gérer mon compte &raquo;.</p>
                </div>
                <div class="Profile__metas" v-if="$user.type === $enums.UserType.COMPANY">
                    <div class="Profile__metas-item">
                        <b>N° Siret: </b>
                        <span v-if="profile.siret">{{ profile.siret }}</span>
                        <span v-else>N/A</span>
                    </div>
                    <div class="Profile__metas-item">
                        <b>Code NAF: </b>
                        <span v-if="profile.naf">{{ profile.naf }}</span>
                        <span v-else>N/A</span>
                    </div>
                </div>
            </div>
            <div class="Profile__informations">
                <h3 class="Profile__informations-title">Mes coordonnées</h3>
                <div class="Profile__informations-item Profile__informations-item--address">
                    <div v-if="profile.address">
                        {{profile.address.line1}} <br>
                        <b>{{profile.address.zip}} {{profile.address.city}}</b>
                    </div>
                    <span v-else>N/A</span>
                </div>
                <div class="Profile__informations-item Profile__informations-item--tel">
                    <span v-if="profile.phone">{{ profile.phone }}</span>
                    <span v-else>N/A</span>
                </div>
                <div class="Profile__informations-item Profile__informations-item--email">
                    {{ $user.email }}
                </div>
                <button type="button" @click="manageAccount" class="Btn Btn--block Btn--stroked Btn--small">
                    Gérer mon compte
                </button>
            </div>
        </section>
    </div>
</template>

<script>
    import ProfilePicture from "./ProfilePicture";
    import Modal from './Modals/Layouts/DialogLayout';
    import ModalBus from "../eventBus";
    import AccountModal from "./Modals/Account/AccountModal";
    import {actions} from "../store";
    import Formations from "./Folders/Formations";

    export default {
        components: {Formations, ProfilePicture, Modal},
        computed: {
            profile: function () {
                return this.$user.profile;
            }
        },
        methods: {
            manageAccount: function () {
                ModalBus.open({component: AccountModal})
            },
            fetchData: function () {
                actions.fetchUser();
            }
        }
    }
</script>
